import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Typography,
} from "@mui/material";
import PlusOneIcon from "@mui/icons-material/PlusOne";
import Storefront from "@mui/icons-material/Storefront";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Sector } from "types/Sector";
import { Branch } from "types/Branch";
import { useState } from "react";
import CreateEditBranch from "./CreateEditBranch";
import BranchesMap from "./BranchesMap";
import { Edit, MonetizationOn, Visibility } from "@mui/icons-material";
import FeedbackViewModal from "./FeedbackViewModal";
import CreateBranchDeposit from "./CreateBranchDeposit";
import { toCurrencyFormat } from "utils/formatter";

type Props = {
  selectedBranch: Branch | null;
  sector: Sector;
  changeBranch: (branch: Branch) => void;
};

export default function BranchesTab({ sector, changeBranch, selectedBranch }: Props) {
  const branches = sector.branches;
  const [isEditOrCreateModalOpen, setIsEditOrCreateModalOpen] = useState(false);
  const [isCreateDepositModalOpen, setIsCreateDepositModalOpen] = useState(false);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  const [windowAnchor, setWindowAnchor] = useState<any | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditBranch = () => {
    setIsModalOpen(true);
    setWindowAnchor(null);
  };

  const handleAddBranch = () => {
    setIsEditOrCreateModalOpen(true);
  };

  const handleCreateDeposit = () => {
    setIsCreateDepositModalOpen((prev) => !prev);
  };

  const handleCloseModal = () => {
    setIsEditOrCreateModalOpen(false);
  };

  const handleFeedbackModal = () => {
    setIsFeedbackModalOpen((prev) => !prev);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={4} md={5}>
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={handleAddBranch}>
                <ListItemIcon>
                  <PlusOneIcon />
                </ListItemIcon>
                <ListItemText primary="Add Branch" />
                <ListItemIcon>
                  <ChevronRightIcon />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <Box
              sx={{
                height: "700px",
                overflow: "auto",
              }}
            >
              {branches?.map((branch) => {
                const { name, id } = branch;
                return (
                  <ListItem key={id} disablePadding>
                    <ListItemButton onClick={() => changeBranch(branch)}>
                      <ListItemIcon>
                        <Storefront />
                      </ListItemIcon>
                      <ListItemText primary={name} />
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          marginLeft: "auto",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" color="textSecondary" fontWeight={500}>
                          {toCurrencyFormat(branch?.wallet?.currentBalance || 0)}
                        </Typography>
                        <IconButton aria-label="View" size="small" onClick={handleCreateDeposit}>
                          <MonetizationOn color="info" />
                        </IconButton>
                        <IconButton aria-label="View" size="small" onClick={handleFeedbackModal}>
                          <Visibility color="success" />
                        </IconButton>
                        <IconButton aria-label="Edit" size="small" onClick={handleEditBranch}>
                          <Edit color="primary" />
                        </IconButton>
                      </Box>
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </Box>
          </List>
        </Grid>

        <Grid item xs={12} sm={8} md={7}>
          {branches && (
            <BranchesMap
              windowAnchor={windowAnchor}
              setWindowAnchor={setWindowAnchor}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              changeBranch={changeBranch}
              selectedBranch={selectedBranch}
              sector={sector}
              branches={branches}
            />
          )}
        </Grid>
      </Grid>

      {isEditOrCreateModalOpen && (
        <Modal
          open={isEditOrCreateModalOpen}
          onClose={handleCloseModal}
          sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <>
            <CreateEditBranch branch={null} onCancel={handleCloseModal} />
          </>
        </Modal>
      )}

      {selectedBranch && isFeedbackModalOpen && (
        <Modal
          open={isFeedbackModalOpen}
          onClose={handleFeedbackModal}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ width: "90%", maxWidth: 700 }}>
            {" "}
            <FeedbackViewModal branch={selectedBranch} />
          </Box>
        </Modal>
      )}

      {selectedBranch && isCreateDepositModalOpen && (
        <Modal
          open={isCreateDepositModalOpen}
          onClose={() => setIsCreateDepositModalOpen(false)}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ width: "90%", maxWidth: 700 }}>
            <CreateBranchDeposit branch={selectedBranch} onComplete={() => setIsCreateDepositModalOpen(false)} />
          </Box>
        </Modal>
      )}
    </>
  );
}
